import * as React from "react"
import {InputAdornment} from "@mui/material";
import {translateCountryName} from "@ui-seeker/utils";
import {AutocompleteAjaxSeeker, FlagsIconSeeker} from "@ui-seeker/core"

import {LabelCountry} from "@components"
import {BACKEND_APIS} from "@constants"
import {country} from "../@signals";


export default function UnmatchedNewProductsCountryAutocomplete({ ...props }) {

    const inputProps = props?.multiple ? null : {
        startAdornment: props.value || country.value ? <InputAdornment position="start" sx={{  ml: 2, mt: .5, flexShrink: 0 }}>
            <FlagsIconSeeker countryName={props.value || country.value} />
        </InputAdornment> : null
    }

    return <AutocompleteAjaxSeeker
        urlAjax={`${BACKEND_APIS.UNMATCHED}/new-products/market`}
        label="Market"
        multiple
        value={country.value}
        placeholder="All Markets"
        onChange={e => country.value = e.target.value}
        getOptionLabel={({ label }) => translateCountryName(label)}
        formatOptionLabel={({ label }) => <LabelCountry country={label} label={translateCountryName(label)} />}
        inputProps={inputProps}
        {...props}
    />
}